"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RawModal = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Button = require("../Button");
var _PendingIndicator = _interopRequireDefault(require("../PendingIndicator"));
var _Overlay = _interopRequireDefault(require("../Overlay"));
var _Portal = _interopRequireDefault(require("../Portal"));
var _useAnimation = require("./useAnimation");
var _styles = require("./styles");
const renderActionButtons = actions => _react.default.Children.toArray(actions);
const RawModal = exports.RawModal = (0, _styledComponents.withTheme)(({
  active = false,
  onClose = () => {},
  title = '',
  containerId,
  children,
  image = null,
  actions = [],
  headerActions = [],
  headerContent = null,
  onOverlayClick = () => {},
  isLoading = false,
  hasCloseBtn = false,
  visibleButtonsLimit,
  leftVisibleButtonsLimit,
  className,
  buttonsStrategy,
  icon,
  fullScreenMode = false,
  theme,
  testId
}) => {
  const CustomIcon = icon;
  return _react.default.createElement(_Portal.default, {
    id: containerId
  }, _react.default.createElement(_Overlay.default, {
    active: active,
    onEscKeyDown: !isLoading ? onClose : null,
    onClick: onOverlayClick,
    className: className
  }, _react.default.createElement(_styles.ModalContainer, {
    active: active,
    "data-test-id": testId,
    fullScreenMode: fullScreenMode
  }, image && theme.name === 'mds' && _react.default.createElement(_styles.ImageContainer, null, image), title && _react.default.createElement(_styles.Header, null, icon && theme.name !== 'mds' && _react.default.createElement(_styles.HeaderIcon, null, _react.default.createElement(CustomIcon, null)), _react.default.createElement(_styles.HeaderTitle, null, title), headerContent && theme.name !== 'mds' && _react.default.createElement(_styles.HeaderAdditionalContent, null, headerContent), (onClose && hasCloseBtn || !!_react.default.Children.count(headerActions)) && _react.default.createElement(_styles.HeaderActions, null, renderActionButtons(headerActions), onClose && hasCloseBtn && _react.default.createElement(_styles.CloseBtn, {
    disabled: isLoading,
    onClick: !isLoading ? onClose : null
  }))), image && theme.name !== 'mds' && _react.default.createElement(_styles.ImageContainer, null, image), _react.default.createElement(_styles.Body, {
    isLoading: isLoading
  }, _react.default.createElement(_styles.Content, null, children), isLoading && _react.default.createElement(_PendingIndicator.default, null)), _react.default.Children.count(actions) > 0 && _react.default.createElement(_Button.ButtonGroup, {
    fullWidthButton: true,
    visibleButtonsLimit: visibleButtonsLimit,
    leftVisibleButtonsLimit: leftVisibleButtonsLimit,
    strategy: buttonsStrategy
  }, renderActionButtons(actions)))));
});
const Modal = props => {
  const [active, canRender] = (0, _useAnimation.useAnimation)(props, props.delay);
  return canRender && _react.default.createElement(RawModal, (0, _extends2.default)({}, props, {
    active: active
  }));
};
var _default = exports.default = Modal;